import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { ALS_ERLEDIGT_MARKIEREN_LABEL } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { ForceTrue } from 'src/lib/validation/ValidationTypes';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import PruefAssistenz from '../../../../../antrag-components/PruefAssistenz';
import { checkIfPruefAssitenzNeedsToValidate } from '../../../../../application-helper-function/AppHelperfunctions';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const DurchfuehrungHOLMAntragLogMob: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<PruefAssistenz
				statusPath={P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Durchfuehrung_HOLM_Pruefstatus.path}
				hinweisPath={
					P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Durchfuehrung_HOLM_Hinweis_Antragsteller.path
				}
				ueberarbeitetAmPath={
					P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Durchfuehrung_HOLM_Ueberarbeitet_Am.path
				}
				erledigtPath={P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Durchfuehrung_HOLM_Erledigt.path}
				formStruc={formStrucPruefAssistenz()}
			/>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default DurchfuehrungHOLMAntragLogMob;

const formStrucPruefAssistenz = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Durchfuehrung_HOLM_Erledigt,
					label: ALS_ERLEDIGT_MARKIEREN_LABEL,
					validation: [{ validateFunction: ForceTrue }],
				},
			],
		},
	];
	return struc;
};
const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Durchfuehrung_HOLM],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucDurchfuehrungHOLMAntragLogMob = (application: any) => {
	if (
		checkIfPruefAssitenzNeedsToValidate(
			application,
			P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Durchfuehrung_HOLM_Pruefstatus.path,
			P.Projektbeschreibung_Logistik_Und_Mobilitaet_Antrag.schema.attributes.Pruefung_Durchfuehrung_HOLM_Erledigt.path,
		)
	)
		return concat(formStrucPruefAssistenz(), formStruc());
	return concat(formStruc());
};
